import {
  TCoefficientReport,
  TPartOfCoefficientReport,
} from '@/pages/supplies-management/children/warehouses-limits/redux/warehouses-limits-module/types';

type TGetFormattedTableCells = {
  item?: TPartOfCoefficientReport;
  maxLengthOfData: number;
};

type TGetFormattedTableCellsReturn = Array<
  Partial<TCoefficientReport> & Pick<TCoefficientReport, 'coefficient'>
>;

/* хелпер для форматирования таблицы, что бы не было пустых колонок
добавляем отрицательный коеф в зависимости от наполнености данных c бека */
export const getFormattedTableCells = ({
  item,
  maxLengthOfData,
}: TGetFormattedTableCells): TGetFormattedTableCellsReturn => {
  if (!item) {
    return Array.from({ length: maxLengthOfData }, () => ({
      coefficient: -1,
    }));
  }
  if (item.length !== maxLengthOfData) {
    return [
      ...item,
      ...Array.from({ length: maxLengthOfData - item.length }, () => ({
        coefficient: -1,
      })),
    ];
  }

  return item;
};
